// Component Name:  ToastMessage
// Author: Lavanya S
// Platform:
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Date: 03-07-2024
// Integrated on: 10-04-2025
// Description:  This component is designed to handle the display of toast notifications,
// which are pop-up messages typically used to communicate brief information or alerts to users.
// They appear temporarily at the top of the screen, user can close this notification,
// if not closed by user by default it disappears after 5 seconds.
// Props: 1. toastData is an Object, contains id(current time), toastType, toastMessage, length(number of toast messages)=> to stack the messages,
// 2. onClose function
// Dependencies: React library
// Interfaces: props
// Maintenance History: 1.0 First Version

import React from "react";
import LK_Information_Light from "../../assets/images/infobar/LK_Information_Light.svg";
import LK_Information_Dark from "../../assets/images/infobar/LK_Information_Dark.svg";
import LK_Close_Light from "../../assets/images/infobar/LK_Close_Light.svg";
import LK_Close_Dark from "../../assets/images/infobar/LK_Close_Dark.svg";

import LK_Information from "../../assets/images/infobar/LK_Information.svg";
import LK_Close from "../../assets/images/infobar/LK_Close.svg";
import { lkBlue, lkGray, lkGreen, lkOrange, lkRed, lkYellow } from "./styleComponents";
import { connect } from "react-redux";

const ToastMessage = (props) => {
  const { toastData, onClose, layoutType } = props;
  // background colors for toast messages
  const bgColor = {
    regular: lkBlue,
    success: lkGreen,
    failure: lkRed,
    reminder: lkOrange,
    warning: lkYellow,
    error: lkGray,
  };

  // styles
  const styles = {
    wrapper: {
      position: "fixed",
      width: "100%",
      zIndex: 2000,
    },
    container: {
      paddingTop: `${50 - toastData.customPad * 5}px`,
      position: "absolute",
      top: "10%",
      left: "50%",
      transform: "translateX(-50%)",
      width: layoutType === "vertical" ? "488px" : "95%",
      height: "91px" ,
    },
    toastContainer: {
      minWidth: "40%",
      height: "90px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "5px 30px",
      border: "3px solid white",
      backgroundColor: bgColor[toastData?.type],
      borderRadius: "48px",
      color: toastData?.type === "warning" ? " #3C3C3C" : "white",
      boxShadow: "0 10pt 20pt rgba(0, 0, 0, 0.25)",
    },
    infoMessage: {
      display: "flex",
      alignItems: "center",
      justifyContent: "left",
      gap: "15px",
    },
    infoIcon: {
      height: "31px",
      weight: "31px",
    },

    closeIcon: {
      width: "15px",
      color: "white",
      cursor: "pointer",
      marginLeft: "10px",
    },

    header: {
      fontSize: "14px",
      fontWeight: "700",
      color: toastData?.type === "warning" ? "#000" : "#fff",
      margin: 0,
    },
    message: {
      fontSize: "14px",
      fontWeight: "400",
      margin: 0,
    },
  };

  // to close the toast message automatically after 5 sec
  React.useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <div style={styles.toastContainer}>
          <div style={styles.infoMessage}>
            <img src={toastData?.type === "warning" ? LK_Information_Dark : LK_Information_Light} style={styles.infoIcon} alt="info svg" />
            <div style={styles.messageContainer}>
              <h5 style={styles.header}>{toastData?.title.toUpperCase()}</h5>
              <p style={styles.message}>{toastData?.message}</p>
            </div>
          </div>
          <img src={toastData?.type === "warning" ? LK_Close_Dark : LK_Close_Light} alt="close svg" style={styles.closeIcon} onClick={onClose} />
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  layoutType: state.Layout.layoutType,
});

export default connect(mapStateToProps)(ToastMessage);
